import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Heart, Crown, Trophy } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * AmbassadorPanel
 * Toont voortgang naar volgende mijlpaal + leaderboard
 * props: count, milestones: [{at,slug,name}], onInvite()
 */
export default function AmbassadorPanel({ count = 0, milestones = [], onInvite }) {
  const [leaderboard, setLeaderboard] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/referrals/leaderboard?limit=5`)
      .then((r) => setLeaderboard(r.data.leaderboard || []))
      .catch(() => {});
  }, []);

  const next = milestones.find((m) => count < m.at);
  const progress = next ? Math.min(1, count / next.at) : 1;

  return (
    <div className="bg-card border border-border rounded-2xl p-4" data-testid="ambassador-panel">
      <div className="flex items-center gap-2 mb-3">
        <Heart className="w-5 h-5 text-old-rose" />
        <h2 className="font-display text-xl text-foreground mr-auto">Vrienden Uitnodigen</h2>
        <span
          data-testid="ambassador-count"
          className="px-2 py-0.5 rounded-full bg-old-rose/20 text-old-rose text-xs font-bold"
        >
          {count}
        </span>
      </div>

      {next ? (
        <>
          <p className="text-xs text-muted-foreground mb-2">
            Nog <b>{next.at - count}</b> vriend(en) en je krijgt de <b className="text-gold">{next.name}</b>!
          </p>
          <div className="relative h-3 rounded-full bg-muted overflow-hidden mb-3">
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-old-rose to-gold transition-all"
              style={{ width: `${progress * 100}%` }}
            />
          </div>
        </>
      ) : (
        <p className="text-xs text-muted-foreground mb-3">
          Alle mijlpalen gehaald — je bent een Legende! 🏆
        </p>
      )}

      <button
        onClick={onInvite}
        data-testid="ambassador-invite-btn"
        className="w-full mb-3 rounded-full bg-old-rose hover:bg-old-rose/90 text-night-blue font-bold py-2 text-sm"
      >
        Nodig een vriendje uit
      </button>

      {leaderboard.length > 0 && (
        <div className="pt-3 border-t border-border">
          <div className="flex items-center gap-1.5 mb-2 text-xs font-accent uppercase tracking-wide text-muted-foreground">
            <Trophy className="w-3 h-3" /> Top ambassadeurs
          </div>
          <ol className="space-y-1">
            {leaderboard.map((l, i) => (
              <li
                key={i}
                data-testid={`leaderboard-${i}`}
                className="flex items-center justify-between text-sm"
              >
                <span className="flex items-center gap-2">
                  <span className={`w-5 text-center text-xs font-bold ${i === 0 ? 'text-gold' : 'text-muted-foreground'}`}>
                    {i + 1}
                  </span>
                  <span className="text-foreground">
                    {i === 0 && <Crown className="w-3.5 h-3.5 text-gold inline mr-1" />}
                    {l.name}
                  </span>
                </span>
                <span className="font-bold text-gold">{l.count}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
